'use client'
import { useEffect, useState } from "react";

// Define possible OS types
type OS = "Android" | "iOS" | "Windows" | "Mac" | "Unknown";

const useDetectMobileOS = (): OS => {
  const [os, setOS] = useState<OS>("Unknown");

  useEffect(() => {
    // Ensure this runs only on client-side
    if (typeof window === "undefined") return;

    const userAgent = navigator.userAgent.toLowerCase();

    if (/android/i.test(userAgent)) {
      setOS("Android");
    } else if (/ipad|iphone|ipod/i.test(userAgent)) {
      setOS("iOS");
    } else if (/win/i.test(userAgent)) {
      setOS("Windows");
    } else if (/mac/i.test(userAgent)) {
      // Differentiate iPadOS (which identifies as Mac in newer versions)
      if (/ipad/i.test(userAgent) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 2)) {
        setOS("iOS");
      } else {
        setOS("Mac");
      }
    } else {
      setOS("Unknown");
    }
  }, []);

  return os;
};

export default useDetectMobileOS;